import React from "react";
import PropTypes from "prop-types";
import { BgImage } from "gbimage-bridge";

/**
 *
 * @param {{image: Object, style: Object, className: string}} props
 */
function BackgroundImageWrapper(props) {
  const { image, style, className, children, ...other } = props;

  if (image?.file?.childImageSharp?.gatsbyImageData) {
    return (
      <BgImage
        image={image.file.childImageSharp.gatsbyImageData}
        className={className}
        style={style}
        {...other}
      >
        {children}
      </BgImage>
    );
  } else if (image?.file?.url) {
    return (
      <div
        className={className}
        style={{
          backgroundImage: `url(${image.file.url})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          ...style,
        }}
        {...other}
      >
        {children}
      </div>
    );
  } else {
    return (
      <div className={className} style={style} {...other}>
        {children}
      </div>
    );
  }
}

BackgroundImageWrapper.propTypes = {
  props: PropTypes.object,
};

export default BackgroundImageWrapper;
